import type {
    DraggableAttributes,
    DraggableSyntheticListeners,
} from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import React from 'react';
import { YStack } from 'smoothie';

import { PlaceholderSection } from './PlaceholderSection';

interface SortableTopLevelItemProps {
    id: string;
    ghostHeight: number;
    data?: Record<string, unknown>;
    children: (props: {
        setActivatorNodeRef: (el: HTMLElement | null) => void;
        listeners?: DraggableSyntheticListeners;
        attributes?: DraggableAttributes;
    }) => React.ReactNode;
}

export const SortableTopLevelItem = ({
    id,
    ghostHeight,
    data,
    children,
}: SortableTopLevelItemProps) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        isDragging,
    } = useSortable({ id, data });

    return (
        <YStack
            ref={setNodeRef as unknown as React.Ref<HTMLElement>}
            data-goal-item-id={id}
            data-goals-waterfall-draggable-id={id}
            marginBottom={12}
            position="relative"
            width="100%"
        >
            {isDragging ? (
                <PlaceholderSection height={ghostHeight} />
            ) : (
                children({ setActivatorNodeRef, listeners, attributes })
            )}
        </YStack>
    );
};
